import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ParamMap, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Accordion } from '../shared/accordion';
import { Analytic } from '../shared/analytic';

import { CookieManagerService, ErrorManagerService, HttpClientService } from '../../../shared/';
import { ApiEndpoints, StatisticsTypes, CookieNames } from '../../constant';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';
import { TranslateService } from '@ngx-translate/core';
import { BackButtonService } from './../../../shared/services/back-button.service';
declare var $: any;

@Component({
  selector: 'app-online-exams',
  templateUrl: './online-exams.component.html',
  styleUrls: ['./online-exams.component.css', './../statistics.component.css']
})
export class OnlineExamsComponent implements OnInit, Accordion {
  public statisticsType: string = StatisticsTypes.online.text;
  public isView: boolean = false;
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  public selectedSubjectProgress;
  public selectedPapersSubjects;
  private subjectProgress = [];
  public selectedItem = 0;
  public subjectArray: any = [];
  public currentSubject: string;
  public statisticsData: any = [];
  public paperMarks: any = [];
  public selectedPaperId;
  public currentPaperPartId;
  public setId;
  public apiRequstWaiter: boolean = true;
  private paperId: string;


  public items: any = [];
  public barChartType: string = 'bar';
  public barChartLegend: boolean = false;
  public barChartData: any[] = [
    { data: [0], label: 'Marks Average', backgroundColor: ['#FFFFFF'] },
  ];

  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: true,
          max: 120
        }
      }]
    },
    animation: {
      duration: 1,
      onComplete: function () {
        var chartInstance = this.chart,
          ctx = chartInstance.ctx;
        ctx.textAlign = 'center';
        ctx.fillStyle = "rgba(0, 0, 0, 1)";
        ctx.textBaseline = 'bottom';

        this.data.datasets.forEach(function (dataset, i) {
          var meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];
            ctx.fillText(data + "%", bar._model.x, bar._model.y - 5);

          });
        });
      }
    }
  };
  public backgroundColor = ['#FFFFFF'];
  public barChartLabels: string[] = [' '];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private httpClientService: HttpClientService,
    private trans: TranslateService,
    private backButtonService: BackButtonService,
    private cookieManagerService: CookieManagerService,
  ) { }

  ngOnInit() {
    this.paperId = this.activatedRoute.snapshot.params['id'];
    if (!this.paperId) {
      window.scrollTo(0, 0);
    }
    this.getStatisticList();

  }

  getStatisticList(firstItem?: any) {
    this.apiRequstWaiter = false;
    // get the overall detils
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getStatisticsOverAll, { [ApiEndpoints.paperSetType]: this.statisticsType, }), null).subscribe(

      res => {
        //KinderJoy
        //setTimeout(() => {
          this.apiRequstWaiter = true;
          if (res.statistics.length > 0) {
            //if no data hide the view
            this.initAccordin(res);
            if (this.paperId) {
              let paper = this.items.filter(paper => {
                if (paper.data._id === this.paperId) {
                  this.onSelectItem(paper);
                }
              });
            }
            this.initChart(res, this.initChartData(res.statistics));
            if (firstItem) {
              this.onSelectFirst();
            }
            this.getFirstSubject(res.statistics);
            this.isView = true;
          }
        //}, 3000);
      });
  }

  /**
   * get Statistic details of paper
   * @param item 
   */
  getPaperByPaperId(id, item) {
    this.currentPaperPartId = id;
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getStatisticsByPaperId, { [ApiEndpoints.papers]: id, }), null).subscribe(
      res => {
        this.initChart(res, this.initChartData(res.statistics));
        this.getFirstSubject(res.statistics);
        this.paperMarks = res.paperMarks;
        item.isShow = true;
      },
      error => {
        item.isShow = false;
      });
  }

  /**
   * Initiate Accordion, Overall accordian at first and other accordion data behid that
   * @param res 
   */
  initAccordin(res) {
    let overallItem = [];
    let otherItems = [];
    let items = [];
    overallItem['_id'] = "overall-menu-bar";
    overallItem['isShow'] = true;
    overallItem['title'] = this.trans.instant('OVERALL_SUMMARY_ONLINE_EXAM');
    otherItems = this.initPaperSetData(res.completePaperSets);
    items = [overallItem, ...otherItems];

    this.items = Analytic.fromJSONArray(items);
  }

  initPaperSetData(paperSets) {
    return paperSets.map(p => {
      p.paperset.isShow = true;
      return p.paperset;
    });
  }

  /**
   * inti the charrt details
   * @param statisticsData 
   */
  initChartData(statisticsData) {

    let label = [];
    let backgroundColor = [];
    let data = [];

    this.statisticsData = statisticsData;

    statisticsData.forEach(stat => {
      // push to lable array
      label.push(stat.category.category);
      // push to background color array
      backgroundColor.push(StatisticsTypes.online.chartColor);
      // backgroundColor.push(this.getRandomColor());
      ;// push to data array
      data.push(stat.percentageMark)
      // push to subject array
      this.subjectArray[stat.category.category] = stat.category._id

    });
    return { label, backgroundColor, data };
  }

  /**
   * customize the chart details
   */
  initChart(res, chartData) {
    // assigh to cart value 
    this.backgroundColor = [];
    this.barChartData = [{
      data: chartData.data, label: 'Marks Average', backgroundColor: chartData.backgroundColor
    }];
    this.barChartLabels = chartData.label;

    setTimeout(function () {
      // update the chart
      if (this.chart && this.chart.chart && this.chart.chart.config) {
        this.chart.chart.config.data.labels = chartData.label;
        this.chart.chart.config.data.datasets = this.barChartData;

        this.chart.chart.update();
      }
    }.bind(this), 10);
  }

  /**
   * get subject details of first one
   * @param statisticsData 
   */
  getFirstSubject(statisticsData) {
    // get all subjects of selected paper
    this.selectedPapersSubjects = statisticsData;

    // to get skills details to first subject
    let statistics = statisticsData[0]
    let id = statistics.category._id;
    this.currentSubject = statistics.category.category;
    this.setSubjectProgress(id);
  }

  /**
   * sunject id
   * @param column 
   */
  setSubjectProgress(column) {

    if (this.selectedItem == 0) {
      this.getsubjectdetailsForOverAll(column);
    } else {
      this.getsubjectdetailsForIndevidual(column);
    }
  }

  /**
   * get subject level in overall section
   * @param column 
   */
  getsubjectdetailsForOverAll(column) {
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getStatisticsOverAllSubjectByPaperType, { [ApiEndpoints.paperSetType]: this.statisticsType, [ApiEndpoints.subjectCategoryid]: column }), null).subscribe(
      res => {
        if (res && res.statistics.length != 0) {
          this.selectedSubjectProgress = res.statistics;
        }
      });
  }

  /**
   * get subject level in paper section
   * @param column 
   */
  getsubjectdetailsForIndevidual(column) {
    this.httpClientService.authGet(ApiEndpoints.replaceParms(ApiEndpoints.getStatisticsByPaperIdCatId, { [ApiEndpoints.statusPaperid]: this.currentPaperPartId, [ApiEndpoints.subjectCategoryid]: column }), null).subscribe(
      res => {
        if (res && res.statistics.length != 0) {
          this.selectedSubjectProgress = res.statistics;
        }
      });
  }

  /**
   * click event of the tabs 
   * @param item 
   */
  onSelectItem(item) {
    this.selectedItem = item;
    let firstItem: boolean = true;
    if (item.data.paperObj && ((item.data.paperObj[0] || {}).paper || {})._id) {
      this.selectedPaperId = ((item.data.paperObj[0] || {}).paper || {})._id;
      this.setId = item.data._id;
      this.getPaperByPaperId(this.selectedPaperId, item);
      this.toggelShowHide(item);
      this.scrollToPosition(item.data._id);
    } else {
      this.selectedItem = 0;
      item.hide ? this.getStatisticList(firstItem) : item.hide = !item.hide;
      // this.onSelectFirst();
      // item.hide ? this.getStatisticList() : item.hide = !item.hide;
      // console.log('else');
    }

  }

  /**
  * subject selection
  */
  changeSubject(subject) {
    let id = subject.category._id;
    this.currentSubject = subject.category.category;
    this.setSubjectProgress(id);
  }

  scrollToPosition(id) {
    setTimeout(() => {
      let body = $("html, body");
      let top = $("#" + id).offset() ? $("#" + id).offset().top : "overall-menu-bar";
      body.animate({ scrollTop: top - 150 }, 500, 'swing', function () {
      });
    }, 100);
  }

  /**
   * select the first item of the tab
   */
  onSelectFirst() {
    this.toggelShowHide(this.items[0]);
  }

  toggelShowHide(item) {
    this.items.map(i => {
      i == item ? i.hide = !i.hide : i.hide = true;
      return i;
    });
  }

  /**
   * get subject overview
   * @param e 
   */
  public chartClicked(e: any): void {
    let label = ((e.active[0] || {})._model || {}).label;
    if (label) {
      let id = this.subjectArray[label]
      this.currentSubject = label;

      this.setSubjectProgress(id);
    }
  }

  /**
   * click indiviual papers
   */
  onSelectPaper(paper, item) {
    this.selectedPaperId = paper._id;
    this.getPaperByPaperId(this.selectedPaperId, item);
  }

  /**
   * get random colors to chart
   */
  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  /**
   * view answers
   */
  navigateToAnswer() {
    this.backButtonService.setStaticType('online-exams');
    this.cookieManagerService.setCookie(CookieNames.paperSetKey, this.setId, false, 1);
    this.router.navigate(['home/reports/papers/' + this.currentPaperPartId + '/parts']);
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/statistics/online-exams/online-exams.component.ts